import styles from "./Stats.module.css";

interface StatsProps {
  ongoingEvaluations: number;
  employeesToEvaluate: number;
}

export default function Stats({
  ongoingEvaluations,
  employeesToEvaluate,
}: StatsProps) {
  const stats = [
    {
      label: "Avaliações a decorrer",
      value: ongoingEvaluations,
    },
    {
      label: "Colaboradores por avaliar",
      value: employeesToEvaluate,
    },
  ];

  return (
    <div className={styles.container}>
      {stats.map((stat, index) => (
        <div key={index} className={styles.card}>
          <p className={styles.label}>{stat.label}</p>
          <p className={styles.value}>{stat.value}</p>
        </div>
      ))}
    </div>
  );
}
